export default __webpack_public_path__ + "1fecde87209f110a4a56c0fedbea3b6d.png";